import React, { useEffect, useRef, useState } from 'react';
import PropTypes from "prop-types";

export default function NiprNameChangeModal({
    niprAgentNameChange,
    niprAgencyNameChange,
    setNiprNameChangeAccepted = () => { }
}) {
    const gdsModelRef = useRef();
    const gotItButtonRef = useRef();
    const [open, setOpen] = useState();

    useEffect(() => {
        gdsModelRef.current.addEventListener("modal-closed", onModalClosed);
    }, []);

    useEffect(() => {
        setOpen(niprAgencyNameChange || niprAgentNameChange)
    }, [niprAgencyNameChange, niprAgentNameChange]);

    function onModalClosed() {
        setNiprNameChangeAccepted(true);
        setOpen(null);
    };

    return (
        <gds-modal ref={gdsModelRef} type="modal" open={open}>
            <span slot="header">Name Updated</span>
            <div>
                {niprAgentNameChange && (
                    <>
                        <p>
                            Your name has been updated to match the name registered with the National Insurance Producer Registry (NIPR).
                        </p>
                        <h5>Entered Name</h5>
                        <p>{niprAgentNameChange.enteredFirstName} {niprAgentNameChange.enteredLastName}</p>
                        <h5>Updated Name</h5>
                        <p>{niprAgentNameChange.updatedFirstName} {niprAgentNameChange.updatedLastName}</p>
                    </>
                )}

                {niprAgentNameChange && niprAgencyNameChange && (
                    <span className="stroke-separator mt-5"></span>
                )}

                {niprAgencyNameChange && (
                    <>
                        <p>
                            Your Agency Name has been updated to match the name registered with the National Insurance Producer Registry (NIPR).
                        </p>
                        <h5>Agency Name</h5>
                        <p>{niprAgencyNameChange.enteredAgencyName}</p>
                        <h5>Updated Agency Name</h5>
                        <p>{niprAgencyNameChange.updatedAgencyName}</p>
                    </>
                )}
            </div>

            <gds-button
                ref={gotItButtonRef}
                appearance="primary"
                slot="buttons"
                onClick={onModalClosed}
            >
                Got it
            </gds-button>
        </gds-modal>
    );
}

NiprNameChangeModal.propTypes = {
    niprAgentNameChange: PropTypes.shape({
        enteredFirstName: PropTypes.string,
        enteredLastName: PropTypes.string,
        updatedFirstName: PropTypes.string,
        updatedLastName: PropTypes.string
    }),
    niprAgencyNameChange: PropTypes.shape({
        enteredAgencyName: PropTypes.string,
        updatedAgencyName: PropTypes.string
    }),
    setNiprNameChangeAccepted: PropTypes.func
};